import * as React from "react";
import { CtrlColumns } from "src/components/tables/TableStore";
import { Button, Dropdown, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import { SettingsIconStd } from "src/common/icons";
import { useClickOutside } from "src/common/useClickOutside";
import { CloseOutlined } from "@ant-design/icons";
import { t } from "i18next";
import styles from "./ColumnsSettings.module.less";
import { ColumnSettingsList } from "./ColumnSettingsList";

interface PropsColumnsSettings {
  store: CtrlColumns;
  extraButtons?: React.ReactNode;
  freezeLine?: boolean;
}

export const ColumnsSettings: React.FC<PropsColumnsSettings> = observer(
  ({ store, extraButtons, freezeLine }: PropsColumnsSettings) => {
    const [open, setOpen] = React.useState(false);
    const ref = useClickOutside(() => {
      setOpen(false);
    });

    return (
      <Dropdown
        menu={{ className: styles.menu }}
        dropdownRender={() => (
          <div ref={ref} className={styles.sortableContainer}>
            <div className={styles.sortableList}>
              <ColumnSettingsList store={store} freezeLine={!!freezeLine} />
            </div>
            {extraButtons && (
              <div className={styles.extraButtons}>{extraButtons}</div>
            )}
          </div>
        )}
        open={open}
        placement="bottomRight"
      >
        {open ? (
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={() => setOpen(false)}
          />
        ) : (
          <Tooltip title={t("Customizing the column display")}>
            <Button
              type="text"
              icon={<SettingsIconStd />}
              onClick={() => setOpen(true)}
            />
          </Tooltip>
        )}
      </Dropdown>
    );
  },
);
